<div class="dialog-container">
  <div class="dialog-content">
    <div class="dialog-header">
      <h2>QR Generator</h2>
      <button class="close-button" (click)="closeDialog()">×</button>
    </div>
    <div class="qr-container" >
      <qrcode
        [qrdata]="qrData"
        [width]="width"
        [errorCorrectionLevel]="'M'"
        class="qr-code"
      ></qrcode>
      <div class="dialog-actions">
       {{qrData}}
      </div>
    </div>
  </div>
</div>